module.exports = __webpack_public_path__ + "static/media/udemy_logo.e17e3d09.svg";